import { AxiosPromise, AxiosResponse } from 'axios';

import { ProfileApiResponse } from 'src/data/ProfileApi/ProfileApi.types';
import { carmaAuthClientLegacy } from 'src/services/instance/carmaAuthClientLegacy';

import { carmaClientLegacy } from './instance/carmaClientLegacy';
import { ProfileUpdatePayload, SignupPayload, UserResponse, VerificationCodeResponse } from './type/AuthService.type';

// Using any in this file because it out of scope TECH-6539
const AuthService = {
  async signUp(formData: SignupPayload): Promise<any> {
    const res = await carmaAuthClientLegacy.post('/customer/signup', formData);

    return res.data;
  },

  signIn(formData: any): Promise<any> {
    return carmaAuthClientLegacy.post('/auth/password', formData);
  },

  getProfile(): AxiosPromise<ProfileApiResponse> {
    return carmaClientLegacy.get('/me/profile');
  },

  async updateProfile(data: ProfileUpdatePayload) {
    const res = await carmaClientLegacy.patch('/me/profile', data);
    return res.data;
  },

  async financeRate(data: any) {
    const res = await carmaClientLegacy.post('me/finance/rate', data);
    return res;
  },

  async verify(formData: any) {
    const res = await carmaAuthClientLegacy.patch('/customer/verification', formData);
    return res.data;
  },

  async resendVerify(formData: any) {
    const res = await carmaAuthClientLegacy.post('/customer/verification', formData);
    return res.data;
  },

  async forgotPassword(formData: any) {
    const res = await carmaAuthClientLegacy.post('/password/token', formData);

    return res.data;
  },
  async createNewPassword(formData: any) {
    const res = await carmaAuthClientLegacy.post('/password/reset', formData);
    return res.data;
  },
  async createNewPasswordWithToken(formData: any): Promise<any> {
    const res = await carmaAuthClientLegacy.post('/password/reset', formData);
    return res.data;
  },

  async getUserByEmail(email: string): Promise<UserResponse> {
    const res: AxiosResponse<UserResponse> = await carmaAuthClientLegacy.get(`/customer/email/${email}`);
    return res.data;
  },

  async getPhoneVerificationCode(phone: string): Promise<VerificationCodeResponse> {
    const res: AxiosResponse<VerificationCodeResponse> = await carmaAuthClientLegacy.post(`/customer/verify`, {
      phone,
    });
    return res.data;
  },

  async checkPhoneNumberIsTaken(phone: string): Promise<{}> {
    const res: AxiosResponse<VerificationCodeResponse> = await carmaAuthClientLegacy.post('/customer/phone', { phone });
    return res.data;
  },
};

export default AuthService;
